import Content from '../../content.js';

namespace('IO.Views.VirtualNodes', function (exports) {
  'use strict';

  var DynamicGroupForm = IO.Views.Components.DynamicGroupForm,
    New = Content.extend({
      sendOnEnter: false,

      dom: {
        SELECT2_FIELD: '.select2select',
        TYPE_OF_SERVER_SELECTOR: '.type-of-server-selector',
        CURRENT_HOSTNAME_FORM: '.server-form .current-hostname',
        NODES_FORM: '#virtual-node-form',
        PUPPET_PROFILES: '.virtual_node_puppet_profiles',
      },

      events: function () {
        var events = {};

        events['submit ' + this.dom.NODES_FORM] = '_beforeSave';
        return events;
      },

      /*
        PUBLIC FUNCTIONS
      */
      afterRender: function () {
        this.listenTo(this.dynamicForm, 'after:filter', this.checkRadioButtons);
      },

      onDestroy: function () {
        this.dynamicForm.remove();
      },

      _beforeSave: function () {
        if (!$(this.dom.NODES_FORM).hasClass('puppet-module-changes-yes')) {
          this._checkPuppetModuleChanges();
          return false;
        }

        return true;
      },

      render: function () {
        var $select = this.$(this.dom.SELECT2_FIELD);

        this.puppetProfilesOrder = new PuppetProfilesOrder(this.$el);
        this.dynamicForm = new DynamicGroupForm({
          el: this.$el,
          radio: true,
          formTarget: this.dom.NODES_FORM,
        });
        this.dynamicForm.render();
        this.checkRadioButtons();

        new ServerTypeWarning({ selector: this.dom.TYPE_OF_SERVER_SELECTOR });

        if (!$select.closest('.hide').length) {
          $select.select2();
        }

        PropertyTypeMask.applyMasks.call(this);
        this.selectedPuppetModules = this._getSelectedPuppetModules();
      },

      _checkPuppetModuleChanges: function () {
        var self = this,
          proceed,
          newPuppetModules,
          addedModules,
          removedModules,
          puppetModuleChangesModal;

        proceed = function (shouldProceed) {
          if (shouldProceed) {
            $(self.dom.NODES_FORM).addClass('puppet-module-changes-yes');
            $(self.dom.NODES_FORM).submit();
          } else {
            $(self.dom.NODES_FORM).addClass('puppet-module-changes-no');
          }
        };

        newPuppetModules = this._getSelectedPuppetModules();

        if (
          $(this.selectedPuppetModules).not(newPuppetModules).length === 0 &&
          $(newPuppetModules).not(this.selectedPuppetModules).length === 0
        ) {
          proceed(true);
          return;
        }

        addedModules = $(newPuppetModules)
          .not(this.selectedPuppetModules)
          .get();
        removedModules = $(this.selectedPuppetModules)
          .not(newPuppetModules)
          .get();

        puppetModuleChangesModal = new IO.Views.NodeGroups.PuppetModuleChanges({
          wait: true,
        });
        puppetModuleChangesModal.setModuleChanges(
          'New node',
          addedModules,
          removedModules,
        );
        puppetModuleChangesModal.answer(function (shouldProceed) {
          proceed(shouldProceed);
          puppetModuleChangesModal.destroy();
        });
      },

      _getSelectedPuppetModules: function () {
        return $(this.dom.PUPPET_PROFILES + ' option:selected')
          .map(function () {
            return $(this).text();
          })
          .get();
      },
    });

  exports.New = New;
});
